import React from 'react';
import { Link } from 'react-router-dom';
import useDisplayServices from '../custom-hooks/useDisplayServices';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import remarkUnwrapImages from 'remark-unwrap-images';

function ServicePanels (props) {
  const page = props.page;
  const mode = props.mode;
  const [displayServices, isLoading] = useDisplayServices(page);

  if (isLoading === true) {
    return <p>Loading...</p>;
  }

//   console.log("displayServices = ", displayServices);

  if (mode === "grid") {
    return (
        // grid for landing page
        <div className="panelHolder" id="servPanelHolder">
            <div className="row">
            {displayServices.map((dServices, index) => {
                let ctaURL = "../services/" + dServices.fields.link;
                let panelClass = "col-sm-6 col-lg-6 servBlock"
                const svgString = dServices.fields.svgCode;
                if (index > 1) {
                    panelClass += " secondRow"
                }

                return (
                    <div className={panelClass} key={dServices.fields.title}>
                        <div className="panelSvg">
                            <Link to={ctaURL} reloadDocument className="ctaLink">
                                <div
                                    className="panelIcon panelIconHover"
                                    dangerouslySetInnerHTML={{
                                        __html: svgString,
                                    }}
                                />
                            </Link>
                        </div>
                        <h2 className="panelTitle">{dServices.fields.title}</h2>
                        <p className="panelText">{dServices.fields.description}</p>
                        <Link to={ctaURL} reloadDocument className="ctaLink">
                            FIND OUT MORE...
                        </Link>
                    </div>
                );
            })}
        </div>
        </div>
    );
}

  else {
    //rows for specific service pages
    console.log('check');

    return (
        <div className="panelHolder" id="servPanelHolder">
        {displayServices.map((dServices, index) => {
            const svgString = dServices.fields.svgCode;
            const servDescText = dServices.fields.description;
            return ( 
                <div id={`serv${index}`} className={(index % 2 === 0) ? 'servRight greyBkgd' : 'servLeft'}>
                <div id={`servicePanel${index}`} className="servicePanel">
                    <div className="row">
                    <div className={(index % 2 === 0) ? 'textLeft col-xs-12 col-sm-8 order-first' : 'textRight col-xs-12 col-sm-8 order-last'}>
                    <h2 className='panelTitle'>{dServices.fields.title}</h2>
                    <div className="panelContent">
                        <ReactMarkdown remarkPlugins={[gfm, remarkUnwrapImages]}>{servDescText}</ReactMarkdown>
                    </div>
                    </div>
                    <div className={(index % 2 === 0) ? 'iconRight col-xs-12 col-sm-4 order-last' : 'iconLeft col-xs-12 col-sm-4 order-first'}>
                    <div
                                    className='serviceIcon' 
                                    dangerouslySetInnerHTML={{
                                        __html: svgString,
                                    }}
                                />
                                </div>
                    </div>
                    
                </div>
            </div>
           )
        })}
        </div>
    );


}
};

export default ServicePanels;
